export const PRIMARY_LEARN = {
  10: "#00254C",
  20: "#013166",
  30: "#004A99",
  40: "#0062CC",
  50: "#027BFF",
  60: "#3395FF",
  70: "#67B0FF",
  80: "#99CAFF",
  90: "#CCE5FF",
  95: "#E6F2FF",
  955: "#E6F2FF",
  90_5: "#E6F2FF80",
} as const;

export const PRIMARY_META = {
  10: "#00344D",
  20: "#0B4D60",
  30: "#1A6976",
  40: "#22878E",
  50: "#26878F",
  60: "#32ACAB",
  70: "#6DBABC",
  80: "#96C9CE",
  90: "#C0DCE1",
  95: "#E7F1FA",
  90_5: "#e7f1fa80",
} as const;

export const PRIMARY_SRICHANTANYA = {
  10: "#2A1F01",
  20: "#4C3900",
  30: "#715300",
  40: "#957000",
  50: "#FCC216",
  60: "#FFDA48",
  70: "#FDE06E",
  80: "#FDE79B",
  90: "#FBF0CC",
  95: "#FFF6E0",
  90_5: "#FFF6E080",
} as const;

export const SECONDARY_LEARN = {
  10: "#322C12",
  20: "#655924",
  30: "#978536",
  40: "#CAB249",
  50: "#FCDE5A",
  60: "#FDE57B",
  70: "#FDEB9C",
  80: "#FEF2BD",
  90: "#FEF8DE",
  95: "#FFFCEF",
} as const;

export const SECONDARY_META = {
  10: "#000000",
  20: "#383421",
  30: "#69622D",
  40: "#AD9D2E",
  50: "#FFF000",
  60: "#FFF000",
  70: "#FFF360",
  80: "#FFF698",
  90: "#FFF9C3",
  95: "#FFFFFF",
  90_5: "#FFFFFF80",
} as const;

export const SECONDARY_SRICHANTANYA = {
  10: "#2A1F01",
  20: "#4C3900",
  30: "#715300",
  40: "#957000",
  50: "#FCC216",
  60: "#FFDA48",
  70: "#FDE06E",
  80: "#FDE79B",
  90: "#FBF0CC",
  95: "#FFF6E0",
  90_5: "#FFF6E080",
} as const;

export const TERTIARY = {
  10: "#331800",
  20: "#663100",
  30: "#994900",
  40: "#CC6201",
  50: "#FF7900",
  60: "#FF9533",
  70: "#FFAF66",
  80: "#FFCA99",
  90: "#FFD6B4",
  95: "#FFE4CC",
} as const;

export const NEUTRAL = {
  10: "#080E14",
  20: "#21262D",
  30: "#393E44",
  40: "#52565C",
  50: "#6C6E72",
  60: "#85878A",
  70: "#9D9FA1",
  80: "#CECFD0",
  90: "#E6E7E8",
  95: "#F2F2F2",
  100: "#FFFFFF",
} as const;

export const SUCCESS = {
  10: "#002108",
  20: "#002108",
  30: "#003914",
  40: "#015622",
  50: "#04742D",
  60: "#35C759",
  70: "#5DD37A",
  80: "#86DD9B",
  90: "#AEE9BD",
  95: "#D6F4DE",
} as const;

export const ERROR = {
  10: "#4A0D0D",
  20: "#751313",
  30: "#9E1C1C",
  40: "#C72424",
  50: "#F03E3E",
  60: "#F56363",
  70: "#F98989",
  80: "#FCB2B2",
  90: "#FDDCDC",
  95: "#FEF0F0",
  99: "#F8B4AF",
} as const;

export const WARNING = {
  10: "#2B1A00",
  20: "#2B1A00",
  30: "#583600",
  40: "#8A5200",
  50: "#B36E00",
  60: "#FFAB00",
  70: "#FFBC34",
  80: "#FFCD67",
  90: "#FFDD99",
  95: "#FFEECC",
} as const;

export const TEXT = {
  10: "#101010",
  20: "#666666",
  30: "#A9A9A9",
  40: "#D9D9D9",
  50: "#F5F5F5",
} as const;

export const BACKGROUND = {
  10: "#00364E",
  20: "#FFFFFF",
  30: "#D4E9FF",
  40: "#F1F2F6",
  50: "#F6FAFF",
} as const;

export const TEST = {
  50: "#7A4BFF",
  60: "#9B7EFF",
  95: "#EDE3FF",
  99: "#F7F2FF",
} as const;

export const GRADIENT_1 =
  `linear-gradient(180deg, ${PRIMARY_LEARN[50]} 0%, ${PRIMARY_LEARN[30]} 100%)` as const;

export const GRADIENT_2 = "#7A4BFF" as const;

export const OVERLAY = "rgba(0, 0, 0, 0.5)" as const;

export const OVERLAY_LIGHT = "rgba(255, 255, 255, 0.03)" as const;

export const BUTTON_SUCCESS = "#5DB85D" as const;

export const AINA_CHAT = {
  background: "#C9B5FF",
  pillBackground: "#071641",
  pillShadow: "#0F172A",
  iconBackground: "#EEE6FF",
};

export const DOUBTS_RESOLVED = {
  100: "#FFFFFF",
  80: "#C8F2DB",
  60: "#DFFFF6",
};

export const DOUBT_IMAGE_EDIT_GRADIENT = [
  "rgba(2, 120, 248, 0.00)",
  "rgba(2, 120, 248, 0.10)",
] as const;
